import { render, staticRenderFns } from "./BackendUser.vue?vue&type=template&id=69519040&scoped=true&"
import script from "./BackendUser.vue?vue&type=script&lang=js&"
export * from "./BackendUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69519040",
  null
  
)

export default component.exports